import moment from 'moment'

const filters = {
  void: v => v,
  // Met la première lettre en majuscule
  cap: function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
  },
  // Tronque si dépasse le 'n' ième caractère
  truncate: function (value, count) {
    if (!value) return ''
    value = value.toString()
    return value.length < count ? value : value.substring(0, count) + '...'
  },
  periodToString: function (v) {
    switch (v) {
      case 1:
        return 'Semaine'
      case 2:
        return 'Mois'
      case 3:
        return 'Trimestre'
      case 4:
        return 'Année'
    }
  },
  bool: v => (v ? 'yes' : 'no'),
  dateTime: function (v) {
    return v
      ? moment
          .parseZone(moment(v))
          .local()
          .format('llll')
      : '-'
  },
  date: function (v) {
    return v
      ? moment
          .parseZone(moment(v))
          .local()
          .format('ll')
      : '-'
  }
}

export default filters



// WEBPACK FOOTER //
// ./src/filters/index.js